// extracted by mini-css-extract-plugin
module.exports = {"card1":"CardFour_card1__1HXb9","card2":"CardFour_card2__3Pa5Z","bigHeader":"CardFour_bigHeader__2TTFq","button":"CardFour_button__QBiP0"};